import type { ReactNode } from 'react';

interface BlueprintLabelProps {
  children: ReactNode;
  className?: string;
}

/**
 * Mono architectural stamp (corner / rail labels).
 */
export function BlueprintLabel({ children, className = '' }: BlueprintLabelProps) {
  return (
    <span
      className={`font-mono text-[10px] font-medium uppercase tracking-[0.18em] text-nm-muted/80 ${className}`}
    >
      {children}
    </span>
  );
}
